import ThemePicker from './theme-picker'

let components = {}
components.install = Vue => {
  Vue.use(ThemePicker)
}

export default components
